/* Frequently-bought-together — keep the "This item" tile in step with the
   variant picker.

   Why a separate asset: the section's inline script is already long, and this
   is pure behaviour with no Liquid in it, so it belongs in a cacheable file.

   How it works, and why it costs nothing:
     * Every variant's price, title, availability and image URL is already
       known when the section renders, so the section emits them as one small
       inline JSON blob. There is no fetch and no section re-render.
     * The theme's VariantPicker dispatches `variant:change` on the product
       form with { detail: { variant } } and bubbles:true, so a single
       document-level listener catches it.
     * The tile figure is aspect-ratio 1/1 with object-fit:contain, so swapping
       the image source cannot shift layout.

   The section calls window.fbtVariantSync(root, hooks) once it has built its
   own state, passing the bits it owns (money formatting, re-render, the
   sold-out flag) so there is exactly one place that computes the total.
*/
window.fbtVariantSync = function (root, hooks) {
  var priceEl = root.querySelector('[data-fbt-anchor-price]');
  var imgEl = root.querySelector('[data-fbt-anchor-img]');
  var variantEl = root.querySelector('[data-fbt-anchor-variant]');
  if (!priceEl) return;

  var variants = {};
  try {
    var blob = (root.parentNode && root.parentNode.querySelector('[data-fbt-variants]'))
      || document.querySelector('[data-fbt-variants]');
    if (blob) variants = JSON.parse(blob.textContent) || {};
  } catch (e) {
    variants = {};
  }

  function apply(variant) {
    var v = variants[String(variant.id)];
    // Fall back to the event payload if the map misses. Shouldn't happen, but a
    // stale cached section beats showing a price the cart won't honour.
    var price = v ? v.p : variant.price;
    var title = v ? v.t : variant.title;
    var avail = v ? v.a : variant.available !== false;
    var img = v ? v.i : null;

    priceEl.dataset.variantId = String(variant.id);
    priceEl.dataset.price = String(price);
    priceEl.textContent = hooks.money(price);

    if (variantEl) {
      variantEl.textContent = (title && title !== 'Default Title') ? title : '';
    }

    if (imgEl && img) {
      // 400w already covers the 13rem tile at 2x, so drop srcset instead of
      // rewriting it and let the browser use src.
      imgEl.removeAttribute('srcset');
      imgEl.removeAttribute('sizes');
      if (imgEl.getAttribute('src') !== img) imgEl.setAttribute('src', img);
    }

    hooks.setSoldOut(!avail);
    hooks.render();
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant || !variant.id) return;
    // Only react to this product's picker — an id we don't know belongs to some
    // other product form on the page.
    if (!variants[String(variant.id)]) return;
    apply(variant);
  });

  // Seed the sold-out state on first paint. Liquid renders whichever variant is
  // selected, and a ?variant= deep link can point at an unavailable one — in
  // which case the CTA would otherwise read "Bundle + Ship" and fire an add that
  // Shopify rejects. Only the flag is seeded: price, label and image are already
  // correct from Liquid, so leave them (and the responsive srcset) alone.
  var initial = variants[String(priceEl.dataset.variantId)];
  if (initial && initial.a === false) {
    hooks.setSoldOut(true);
    hooks.render();
  }
};
